import React from 'react';
import { useSettings } from '../../providers/SettingsContext';

const MaintenancePage = () => {
  const { settings } = useSettings();
  const title = settings?.maintenanceMode?.title || 'Sitio en mantenimiento';
  const message = settings?.maintenanceMode?.message || 'Volvemos pronto. ¡Gracias por tu paciencia!';

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%)',
      color: '#ffffff',
      textAlign: 'center',
      padding: '40px 20px',
      fontFamily: 'inherit',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.05)',
        border: '1px solid rgba(255,255,255,0.1)',
        borderRadius: '24px',
        padding: '60px 50px',
        maxWidth: '520px',
        width: '100%',
        backdropFilter: 'blur(10px)',
      }}>
        <div style={{
          width: '80px',
          height: '80px',
          background: 'var(--color-primary, #1f8e38)',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 28px',
          fontSize: '36px',
          boxShadow: '0 0 40px rgba(31,142,56,0.4)',
        }}>
          <i className="fas fa-wrench" />
        </div>

        <h1 style={{
          fontSize: '2rem',
          fontWeight: '700',
          marginBottom: '16px',
          lineHeight: '1.2',
        }}>
          {title}
        </h1>

        <p style={{
          fontSize: '1.1rem',
          color: 'rgba(255,255,255,0.7)',
          lineHeight: '1.6',
          marginBottom: '32px',
        }}>
          {message}
        </p>

        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '10px',
          color: 'var(--color-primary, #1f8e38)',
          fontSize: '0.9rem',
          fontWeight: '600',
        }}>
          <i className="fas fa-circle-notch fa-spin" />
          <span>Trabajando en mejoras para vos</span>
        </div>
      </div>
    </div>
  );
};

export default MaintenancePage;
